module.exports = __webpack_public_path__ + "img/MyGymChecker-Logo-JPEG-BlackBlue.cddba1d9.jpg";